import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Alert, Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap';
import { Button, Col, Icon, Row } from '../Component';
import TextInput from '../../pages/components/inputs/TextInput';
import { tenant_auth_actions_helper } from '../../actions/actions_helper';
import * as app_consts from "../../utils/app_consts";
import { fail_tenant_update_theoretical_stock_to_physical_stock_balance, loading_tenant_update_theoretical_stock_to_physical_stock_balance, reset_tenant_update_theoretical_stock_to_physical_stock_balance, success_tenant_update_theoretical_stock_to_physical_stock_balance } from '../../reducers/auth_tenant/tenant_update_theoretical_stock_to_physical_stock_balance_Slice';
import { TENANT_UPDATE_THEORETICAL_STOCK_TO_PHYSICAL_STOCK_BALANCE_API } from '../../api/api_data';
import { TENANT_UPDATE_THEORETICAL_STOCK_TO_PHYSICAL_STOCK_BALANCE_ERROR_MSG, TENANT_UPDATE_THEORETICAL_STOCK_TO_PHYSICAL_STOCK_BALANCE_SUCCESS_MSG } from '../../utils/error_success_messages';
import { useSelector } from 'react-redux';
import { messageToast } from '../../utils/Utils';

const initialState = { reason: "", reference_number: "" };

const UpdateStockTakeValuesToPhysicalStockModal = ({ tenant_info, user_info, isOpen, successFunction, closeModal, data }) => {

 const [page_data, setPageData] = useState(data);
 const [open, setOpen] = useState(isOpen);
 const [loading, setLoading] = useState(false);
 const [error, setError] = useState("");
 const dispatch = useDispatch();
 const [formData, setFormData] = useState(initialState);

 useEffect(() => {
  setError("");
  setPageData(data);
  setOpen(isOpen);
  if (isOpen) 
  {
   setFormData({ ...formData, reference_number: data?.reference_number, reason: "" });
  }
 }, [data, isOpen]);

 const handleChange = (e) => {
  setFormData({ ...formData, reason: e.target.value });
 };

 const confirmClick = () => {
  setError("");
  // Dispatch
  dispatch(tenant_auth_actions_helper(loading_tenant_update_theoretical_stock_to_physical_stock_balance, success_tenant_update_theoretical_stock_to_physical_stock_balance, fail_tenant_update_theoretical_stock_to_physical_stock_balance, TENANT_UPDATE_THEORETICAL_STOCK_TO_PHYSICAL_STOCK_BALANCE_ERROR_MSG, TENANT_UPDATE_THEORETICAL_STOCK_TO_PHYSICAL_STOCK_BALANCE_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${TENANT_UPDATE_THEORETICAL_STOCK_TO_PHYSICAL_STOCK_BALANCE_API}`, formData));
 };

 // Listener
 const tenant_update_theoretical_stock_to_physical_stock_balance_listener = useSelector((state) => state.tenant_update_theoretical_stock_to_physical_stock_balance.tenant_update_theoretical_stock_to_physical_stock_balance);

 useEffect(() => {
  if (tenant_update_theoretical_stock_to_physical_stock_balance_listener.status !== app_consts.IDLE)
  {
   if (tenant_update_theoretical_stock_to_physical_stock_balance_listener.status === app_consts.LOADING)
   {
    setLoading(true);
    setError("");
   } else
   {
    setLoading(false);
    if (tenant_update_theoretical_stock_to_physical_stock_balance_listener.status === app_consts.FAIL)
    {
     setError(tenant_update_theoretical_stock_to_physical_stock_balance_listener.message);
     messageToast(tenant_update_theoretical_stock_to_physical_stock_balance_listener.message, app_consts.FAIL);
    } else if (tenant_update_theoretical_stock_to_physical_stock_balance_listener.status === app_consts.SUCCESS)
    {
     successFunction();
     messageToast(TENANT_UPDATE_THEORETICAL_STOCK_TO_PHYSICAL_STOCK_BALANCE_SUCCESS_MSG, app_consts.SUCCESS);
    }
    dispatch(reset_tenant_update_theoretical_stock_to_physical_stock_balance());
   }
  }
 }, [tenant_update_theoretical_stock_to_physical_stock_balance_listener]);


 return (
  <>
   <Modal isOpen={open} className="modal-dialog-centered" size={"md"} >
    <ModalHeader toggle={loading ? "" : closeModal}>Update Stock Take Values to Physical Stock</ModalHeader>
    <ModalBody>
     <Row className="g-4">
      {error && (
       <div className="mb-3 w-100">
        <Alert color="danger" className="alert-icon">
         <Icon name="alert-circle" /> {error}{" "}
        </Alert>
       </div>
      )}
      <p>Are you sure that you want to Update Theoretical Stock to Physical Stock for Products in Stock Take {page_data?.reference_number}?</p>
      <TextInput
       colSize={12}
       parentClassName="mt-2"
       label="Reason"
       type="text"
       id_val="input"
       handleChange={handleChange}
       name="input"
       required
      />
      <Col xl="12" className="d-flex justify-between mt-4 mr-2">
       <Button onClick={() => { setOpen(!isOpen); }} className="btn-secondary">No</Button>
       <Button onClick={confirmClick} disabled={loading || !(formData?.reason)} className=" btn-danger ">
        {loading ? <Spinner size="sm" /> : "YES"}
       </Button>
      </Col>
     </Row>
    </ModalBody>
   </Modal>
  </>
 );
};

export default UpdateStockTakeValuesToPhysicalStockModal;